export default __webpack_public_path__ + "static/media/youtube.34c26f66.png";